module.exports = __webpack_public_path__ + "static/home_nasze_uslugi-fb881541ae49032033c5596ddfbf4842.jpg";